export default __webpack_public_path__ + "static/process-52ead6fdc6cae6a927c9f70bf2d0a923.jpg";